<script>
    import Checkbox from "../common/PrimeVue/Checkbox.vue";

    export default {
        name: "publishFooter",
        components: {Checkbox},
        props: {
            /** @type {PublishElement[]} */
            elements: Array,
            deletedElements: Array,
            showDeleted: Boolean,
            hideCheckbox: Boolean
        },
        computed: {
            length() {
                // add deleted elements to total if they are not shown
                const totalElements = this.showDeleted
                    ? this.elements.length
                    : this.elements.length + this.deletedElements.length;

                return {
                    total: totalElements,
                    published: this.filterAndGetLength(el => el.state === 'synced'),
                    partiallyPublished: this.filterAndGetLength(el => el.state === 'partsynced'),
                    approved: this.filterAndGetLength(el => !el.data.approved),
                    // deleted: this.filterAndGetLength(el => el.state === 'tobedeleted' || el.state === 'deleted'),
                    deleted: this.deletedElements.length
                }
            },
            translations() {
                const countBar = this.length.partiallyPublished
                    ? Lang.langGet(':total Elements | :published Fully / :partiallyPublished partially published | :approved Not approved | :deleted Deleted', {...this.length})
                    : Lang.langGet(':total Elements | :published Published | :approved Not approved | :deleted Deleted', {...this.length});

                return {
                    countBar,
                    showDeleted: Lang.langGet('Show deleted')
                }
            }
        },
        methods: {
            filterAndGetLength(filterFn) {
                return this.elements.filter(filterFn).length;
            }
        },
    }
</script>

<template>
    <div class="d-flex justify-space-between ma-1 publish-footer-padding">
        <div>
            {{translations.countBar}}
        </div>
        <div v-if="!hideCheckbox">
            <checkbox
                binary
                :modelValue="showDeleted"
                @input="$emit('input', $event)"
            />
            {{translations.showDeleted}}
        </div>
    </div>
</template>

<style scoped>
    .publish-footer-padding {
        padding: 3px 4px 7px;
    }
</style>
